import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrowChevronIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.68 6.26C23.27 5.89 22.64 5.91 22.27 6.32L12.01 17.52L1.73998 6.32C1.36998 5.91 0.729983 5.88 0.329983 6.26C-0.0800169 6.63 -0.100017 7.27 0.269983 7.67L11.27 19.67C11.65 20.1 12.37 20.1 12.74 19.67L23.74 7.67C24.11 7.26 24.09 6.63 23.68 6.26Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrowChevronIcon.displayName = 'ArrowChevronIcon';
